import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"

const Sam = () => {

  const data = useStaticQuery(graphql`
    query {
      imageOne: file(relativePath: { eq: "projects_02/gallery/aaa_000.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageTwo: file(relativePath: { eq: "projects_02/gallery/aaa_001.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageThree: file(relativePath: { eq: "projects_02/gallery/aaa_002.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageFour: file(relativePath: { eq: "projects_02/gallery/aaa_003.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageFive: file(relativePath: { eq: "projects_02/gallery/aaa_004.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageSix: file(relativePath: { eq: "projects_02/gallery/aaa_005.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageSeven: file(relativePath: { eq: "projects_02/gallery/aaa_006.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageEight: file(relativePath: { eq: "projects_02/gallery/aaa_007.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageNine: file(relativePath: { eq: "projects_02/gallery/aaa_008.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageTen: file(relativePath: { eq: "projects_02/gallery/aaa_009.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageEleven: file(relativePath: { eq: "projects_02/gallery/aaa_010.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageTwelve: file(relativePath: { eq: "projects_02/gallery/aaa_011.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageThirteen: file(relativePath: { eq: "projects_02/gallery/aaa_012.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageFourteen: file(relativePath: { eq: "projects_02/gallery/aaa_013.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageFifteen: file(relativePath: { eq: "projects_02/gallery/aaa_014.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageSixteen: file(relativePath: { eq: "projects_02/gallery/aaa_015.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageSeventeen: file(relativePath: { eq: "projects_02/gallery/aaa_016.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageEighteen: file(relativePath: { eq: "projects_02/gallery/aaa_017.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      imageNineteen: file(relativePath: { eq: "projects_02/gallery/aaa_018.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  
  return (
    <Layout>
      <section class="body_center">
        <div class="body_center">
          <iframe
            src="https://player.vimeo.com/video/229684736?color=ff9933&title=0&byline=0&portrait=0"
            width="920"
            height="546"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
          <p class="legend">SAM@Bobo. Centre Pompidou. Paris, March 2016</p>
        </div>

        <div>
          <h1 class="mainTitle">A Drawing Machine</h1>
        </div>
        <p>
          SAM is a drawing machine inspired by the first plotters and the
          arrival of computer art in the 1960s. Initiated with one of my
          students from{" "}
          <a href="http://www.esad-amiens.fr/" target="blank">
            ésad d'Amiens
          </a>{" "}
          as part of his apprenticeship, we conceived and built from scratch a
          machine and fondly named it SAM. You can read about the process in
          detail on the{" "}
          <a href="https://samdraws.bitbucket.io/" target="blank">
            official web site
          </a>{" "}
          we made specifically for the project. SAM was first presented to the
          public at the school in 2015 as part of La Nuit Blanche. It has since
          had the honor of travelling to Bordeaux as part of a workshop and
          installation at{" "}
          <a href="https://www.mollat.com/" target="blank">
            La Librairie Mollat
          </a>{" "}
          and stole the show at La Fête du Code at the prestigious Centre
          Pompidou in March 2017.
        </p>

        <p class="notes">
          Project type : Research/Art Installation
          <br />
          Tools used : Custom-made tools in Processing, Arduino
          <br />
          Web site :{" "}
          <a href="https://samdraws.bitbucket.io/" target="blank">
            www.samdraws.bitbucket.io
          </a>
          <br />
          Code Repository :{" "}
          <a
            href="https://bitbucket.org/samdraws/samdraws.bitbucket.io/src/master/"
            target="blank"
          >
            Home Brew Dev
          </a>
        </p>
      </section>

      <section class="body_center">
          <Img fluid={data.imageOne.childImageSharp.fluid} />
        <p class="legend">
          The first portrait drawn by SAM at La Nuit Blanche d'Amiens. 2014
        </p>
      </section>

      <section class="body_wide">
        <div class="cards">
        <Img fluid={data.imageTwo.childImageSharp.fluid} />
        <Img fluid={data.imageThree.childImageSharp.fluid} />
        <Img fluid={data.imageFour.childImageSharp.fluid} />
        <Img fluid={data.imageFive.childImageSharp.fluid} />
        <Img fluid={data.imageSix.childImageSharp.fluid} />
        <Img fluid={data.imageSeven.childImageSharp.fluid} />
        </div>
        <p class="legend">
          Some of the first concepts, a quick and dirty prototype and two of the
          first drawings. 2014
        </p>
      </section>

      <section class="body_center">
      <Img fluid={data.imageEight.childImageSharp.fluid} />
        <p class="legend">
          Detailed plans for SAM's hand and a first prototype.
        </p>
      </section>

      <section class="body_center">
        <p>
          SAM took a few months to put together and we had lots of fun on the
          way. We learnt about mechanics, electronics, woodwork, stepper motors,
          linear motion systems and all that before scratching our heads on what
          SAM would draw. Whilst many recent plotter projects are happy to draw
          directly from vector based files, our ambition for SAM was to focus a
          little more on that 'how' of the drawing process. For this reason the
          project was an on-going affair in which we have tried to develop new
          tools and approaches for each workshop and installation.
        </p>
      </section>
      <br></br>

      <section class="body_center">
        <iframe
          src="https://player.vimeo.com/video/242030138"
          width="970"
          height="546"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        ></iframe>
        <p class="legend">
          Shows some first iterations for software and output. 2015
        </p>
      </section>

      <section class="body_wide">
        <div class="cards2">
        <Img fluid={data.imageNine.childImageSharp.fluid} />
        <Img fluid={data.imageTen.childImageSharp.fluid} />
          <p class="legend">Drawings La Nuit Blanche. 2014</p>
        </div>
      </section>

      <section class="body_center">
        <div class="citation">
          <p>
            "In all the fuss today with AI and machine learning, we tend to
            forget that the machine is not a conscious entity and is incapable
            of 'knowing' anything about art, drawing or aesthetics."
          </p>
        </div>
      </section>

      <section class="body_center">
        <div>
          <h1 class="mainTitle">SAM@Pompidou</h1>
        </div>
      </section>

      <section class="body_center">
        <p>
          For our last project with the Centre Pompidou in Paris we managed to
          put together a really fun and successful installation that began to
          answer in part how SAM could draw. The initial concept was to imagine
          a collaborative art piece that reveals a little of the mystery behind
          code and programming for artistic purposes. A computer program is a
          set of precise instructions. To get kids to understand this basic
          concept, we developed a piece of software that generated join the dot
          diagrams from photos taken by participants. They then proceeded to
          draw their portraits whilst SAM proceeded to draw exactly the same
          image and from the same set of instructions - a list of dots to
          connect.
        </p>
      </section>
      <br></br>

      <section class="body_wide">
        <div class="cards2">
        <Img fluid={data.imageEleven.childImageSharp.fluid} />
        <Img fluid={data.imageTwelve.childImageSharp.fluid} />
        </div>
        <p class="legend">
          Custom-made blob detection software used for the Pompidou
          installation. January 2017
        </p>
      </section>

      <section class="body_center">
        <div class="citation">
          <p>
            "The idea becomes the machine that makes the art."<br></br>
            Sol LeWitt. Paragraphs On Conceptual Art. 1967.
          </p>
        </div>
      </section>

      <section class="body_center">
        <p>
          What ensued from that immensly fascinating creative process was a
          subtle mix of pedagogy for the kids and a critical view of the machine
          vs man for the adults.{" "}
          <a
            href="https://samdraws.bitbucket.io/logs/log012.html"
            target="_blank"
          >
            You can read more about the process behind this project on our
            official website for SAM.
          </a>
        </p>
      </section>
      <br></br>

      <section class="body_wide">
        <div class="cards">
          <Img fluid={data.imageThirteen.childImageSharp.fluid} />
          <Img fluid={data.imageFourteen.childImageSharp.fluid} />
          <Img fluid={data.imageFifteen.childImageSharp.fluid} />
          <Img fluid={data.imageSixteen.childImageSharp.fluid} />
          <Img fluid={data.imageSeventeen.childImageSharp.fluid} />
          <Img fluid={data.imageEighteen.childImageSharp.fluid} />
        </div>
        <p class="legend">
          A small selection of the drawings by SAM during the Pompidou
          installation. March 2016
        </p>
      </section>

      <section>
        <div class="image--full">
        <Img fluid={data.imageNineteen.childImageSharp.fluid} />
          <p class="legend">
            Drawing from Codex workshop in Bordeaux. January 2016
          </p>
        </div>
      </section>
    </Layout>
  )
}

export default Sam
